// extracted by mini-css-extract-plugin
export var content = "_4t-3";
export var list = "_4t-4";
export var settingsContent = "_4t-7";
export var settingsPanel = "_4t-8";
export var state = "_4t-6";
export var triggerBadge = "_4t-2";
export var triggerButton = "_4t-1";
export var triggerShell = "_4t-0";
export var unreadDot = "_4t-5";